export default __webpack_public_path__ + "static/media/background-info.61b9a448.svg";